import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';

import { ShareSection, ShareHeading, ShareDescription, CodeContainer, DescriptionContainer, ShareCode, ShareButton, ShareTicket } from './styles';

const ShareWithFriend = ({ isDesktop, code }) => (
  <ShareSection>
    {isDesktop ? (
      <Fragment>
        <ShareTicket isDesktop={isDesktop}>
          <DescriptionContainer>
            <ShareHeading>Enjoy Free #daycations</ShareHeading>
            <ShareDescription>Refer a friend by giving them your personal code below. Your friend will get a $5 credit towards their first purchase and you will receive a $5 credit after they purchase!</ShareDescription>
          </DescriptionContainer>
          <CodeContainer>
            <ShareCode>{code}</ShareCode>
            <ShareButton type="button">Send to friend</ShareButton>
          </CodeContainer>
        </ShareTicket>
      </Fragment>
    ) : (
      <Fragment>
        <ShareHeading>Enjoy Free #daycations</ShareHeading>
        <ShareDescription>Refer a friend by giving them your personal code below. Your friend will get a $5 credit towards their first purchase and you will receive a $5 credit after they purchase!</ShareDescription>
        <ShareTicket>
          <CodeContainer>
            <ShareCode>xr3z89</ShareCode>
            <ShareButton type="button">Send to friend</ShareButton>
          </CodeContainer>
        </ShareTicket>
      </Fragment>
    )}
  </ShareSection>
);

ShareWithFriend.propTypes = {
  isDesktop: PropTypes.bool,
  code: PropTypes.string,
};

const mapSizesToProps = ({ width }) => ({
  isDesktop: width >= 1195,
});

export default withSizes(mapSizesToProps)(ShareWithFriend);
